// Check for success parameter immediately (before other JS cleans URL)
const urlParams = new URLSearchParams(window.location.search);
const contact = urlParams.get("contact");
const isContactSuccess = contact === "success" && window.location.hash.includes("#contact-section-");

document.addEventListener("DOMContentLoaded", function () {
  const messageDiv = document.getElementById("contact-form-message");

  console.log("Contact form JS loaded");
  console.log("Message div found:", messageDiv);
  console.log("Is contact success:", isContactSuccess);

  if (isContactSuccess && messageDiv) {
    console.log("Showing contact form success message");
    showMessage("Thank you! Your message has been sent successfully. We'll get back to you soon.", "success");
  }

  function showMessage(text, type) {
    console.log("showMessage called:", text, type);
    messageDiv.textContent = text;
    messageDiv.className = `contact-form-message contact-form-message--${type}`;
    messageDiv.style.display = "block";
    console.log("Message div after update:", messageDiv);
  }
});